var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"mb-0"},[_vm._v(_vm._s(_vm.item.ptx))]),_c('p',[_vm._v(_vm._s(_vm.item.ppr)+" Приложения 2 к Порядку")])])
}
var staticRenderFns = []

export { render, staticRenderFns }